import ContractListPage from '../inquiries/ContractListPage';
import { PREPAID_LIST_STATUSES } from '../inquiries/contractTypes';

export default function PrepaidList() {
  return (
    <ContractListPage
      title="선결제 목록"
      desc="계약금(선결제) 입금이 확인되어 MVP 준비 처리를 기다리고 있는 건입니다."
      statusOptions={PREPAID_LIST_STATUSES}
      groupFilter={(item) => Boolean(item.deposit_confirmed_at) && item.status === 'deposit_paid'}
    />
  );
}
